import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes.js';
// import Vue2TouchEvents from 'vue2-touch-events';
// import ProgressBar from 'progressbar.js';

import Template from './components/template.vue'; 
import Welcome from './components/welcome.vue'; 

Vue.use(VueRouter);

// Vue.use(Vue2TouchEvents, {
//     disableClick: true,
//     touchClass: '',
//     tapTolerance: 10,
//     swipeTolerance: 30,
// });
Vue.component('Template', Template);
Vue.component('Welcome', Welcome);


const router = new VueRouter({
	routes,
	mode: 'history'
});

export const eventBus = new Vue();
// export const weatherStartupMobile = new Vue();

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js